import React from 'react'
import { useResume } from '../ResumeProvider'
import { EditableHeading } from './common'
import { useTemplate } from '~/lib/pdf'
import { EditorTextArea, EditorItemProvider } from './EditorItemProvider'
import AiSummary from './AiSummary'

const SummaryEditor = () => {
  const { resumeDocument: { basics } = {} } = useResume()
  const { editorFieldEnabled } = useTemplate()

  if (!editorFieldEnabled('basicsSummary')) return null

  return (
    <EditorItemProvider sectionName="basics" item={basics}>
      <div>
        <div className="mb-4 flex flex-row">
          <EditableHeading
            title="Professional Summary"
            description="Change the heading for the professional summary section of your resume."
            settingName="summaryHeading"
          />
        </div>
        <div className="flex flex-col gap-y-4">
          <EditorTextArea
            autoExpand={true}
            fieldName="summary"
            areaClassName="h-40"
          />
          <AiSummary />
        </div>
      </div>
    </EditorItemProvider>
  )
}
export default SummaryEditor
